import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import {
  border,
  color,
  margin,
  p1Styles,
  p2styles,
  p3styles,
  pad,
  styles,
  table1,
} from "./styles/pdf2Style";
import { t3Data, t3Headers, table1Data } from "./datas";
import getColumnWidth from "../utils/getColoumnWidth";

const Page3 = ({ MUQEEM_POINTS }) => {
  const T3ColumnWidths = [10, 22.5, 22.5, 22.5, 22.5];
  return (
    <View style={styles.content}>
      {/* Table 3 */}
      <View style={[color.bgBlack, styles.textCenter, pad.a5]}>
        <Text style={[color.textWhite, styles.bold]}>
          MUQEEM POINTS DEDUCTION SUMMARY
        </Text>
      </View>
      <View>
        <View
          style={[table1.table, color.bgGray, styles.bold, { borderLeft: 1 }]}
        >
          {t3Headers?.map((heading, i) => {
            return (
              <View
                key={heading}
                style={[
                  table1.cell,
                  {
                    width: T3ColumnWidths[i] + "%",
                  },
                ]}
              >
                <Text style={[styles.wrap, styles.textCenter]}>{heading}</Text>
              </View>
            );
          })}
        </View>
        <View>
          {MUQEEM_POINTS?.length > 0 &&
            MUQEEM_POINTS?.map((data, i) => {
              return (
                <View style={[table1.table]} key={i}>
                  <View
                    key={0}
                    style={[
                      table1.cell,
                      pad.y5,
                      { width: T3ColumnWidths[0] + "%", borderLeft: 1 },
                    ]}
                  >
                    <Text style={[styles.wrap, styles.textCenter]} break>
                      {i + 1}
                    </Text>
                  </View>
                  <View
                    key={1}
                    style={[
                      table1.cell,
                      ,
                      pad.y5,
                      { width: T3ColumnWidths[1] + "%" },
                    ]}
                  >
                    <Text style={[styles.wrap, styles.textCenter1]} break>
                      {data?.particular}
                    </Text>
                  </View>
                  <View
                    key={1}
                    style={[
                      table1.cell,
                      pad.y5,
                      { width: T3ColumnWidths[2] + "%" },
                    ]}
                  >
                    <Text style={[styles.wrap, styles.textCenter]} break>
                      {data?.deduction}
                    </Text>
                  </View>
                  <View
                    key={1}
                    style={[
                      table1.cell,
                      pad.y5,
                      { width: T3ColumnWidths[3] + "%" },
                    ]}
                  >
                    <Text style={[styles.wrap, styles.textCenter]} break>
                      {data?.equivalent_sar}
                    </Text>
                  </View>
                  <View
                    key={1}
                    style={[
                      table1.cell,
                      pad.y5,
                      { width: T3ColumnWidths[4] + "%" },
                    ]}
                  >
                    <Text style={[styles.wrap, styles.textCenter1]} break>
                      {data?.paid_by}
                    </Text>
                  </View>
                </View>
              );
            })}
        </View>
      </View>
    </View>
  );
};

export default Page3;
